import PropTypes from 'prop-types'
import { View } from './View'

/**
 * IBA独自コンポーネントです
 */
export const Avatar = ({ ...props }) => {
    return <View {...props} />
}

Avatar.propTypes = {
    /**
     * ラベル<font color="red">*</font>
     */
    label: PropTypes.string.isRequired,
    /**
     * スタイル変更用のクラス名
     */
    className: PropTypes.any
}

Avatar.defaultProps = {
    label: ''
}
